import {
  Button,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { SQCReponseService } from "../../../service/SQC_form/SQCReponseService";
import { getConnectedUser } from "../../../Helpers/SessionHelpers";
import { userServices } from "../../../service/UserService";
import { EditOutlined } from "@material-ui/icons";

const ResumePostule = ({
  jobId,
  candidatID,
  show = false,
  onAcceptCondition,
  associatonInfo,
  setCurentIndex,
}) => {
  const [loadingPage, setLoadingPage] = React.useState(true);
  const [acceptCondition, setAcceptCondition] = React.useState(false);
  const [resumes, setResumes] = React.useState([]);
  const [association, setAsociation] = useState({});

  const handleFetchMyAssociation = () => {
    userServices.getMyAssociation().then((res) => {
      if (res && res.success) {
        setAsociation(res.data || []);
      }
    });
  };

  const handleFetchResumes = useCallback(() => {
    setLoadingPage(true);
    SQCReponseService.getResume(jobId)
      .then((res) => {
        if (res && res.data) {
          setResumes(res.data || []);
        }
      })
      .finally(() => {
        setLoadingPage(false);
      });
  }, [jobId]);

  const handleAcceptCondition = () => {
    setAcceptCondition(!acceptCondition);
    if (onAcceptCondition) {
      onAcceptCondition(!acceptCondition);
    }
  };

  useEffect(() => {
    if (jobId && show) {
      handleFetchMyAssociation();
      handleFetchResumes();
    }
  }, [jobId, show, handleFetchResumes]);

  return (
    <>
      <Grid
        display={show ? "block" : "none"}
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: "100%" }}
      >
        {/* <Grid container m={2} display={!loadingPage ? "none" : ""}>
          <Skeleton width={"100%"} />
          <Skeleton width={"100%"} />
          <Skeleton width={"100%"} />
          <Skeleton width={"100%"} />
        </Grid> */}
        <Grid item xs={12}>
          <CardHeader
            title={"Résumé des questions répondues"}
            titleTypographyProps={{ textAlign: "center", fontWeight: "bold" }}
          />
          <CardHeader
            title={"Intitulé du Lot"}
            titleTypographyProps={{ variant: "h5" }}
            subheaderTypographyProps={{ variant: "subtitle1" }}
            subheader={
              <Grid container>
                <Grid item xs={12}>
                  <Typography variant="body2" color="textSecondary">
                    LOT : {resumes.at(0)?.libelle_type}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    AMI : {resumes.at(0)?.description}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Zone : {resumes.at(0)?.zone}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Direction/Antenne : {resumes.at(0)?.direction_antenne}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Region : {resumes.at(0)?.region}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    District : {resumes.at(0)?.district}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Commune : {resumes.at(0)?.commune}
                  </Typography>
                </Grid>
              </Grid>
            }
          />
          <Divider variant="middle" />
          {resumes.length > 0 ? (
            resumes.map((resume, index) => (
              <CardHeader
                title={
                  <Grid>
                    {`Q${index + 1} : ${resume.question}`}
                    <Button
                      title={`Modifier la réponse de la question N° ${index + 1}`}
                      color="primary"
                      onClick={(e) => setCurentIndex(index)}
                      startIcon={<EditOutlined />}
                    ></Button>
                  </Grid>
                }
                titleTypographyProps={{ variant: "h6" }}
                key={index}
                subheader={
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary">
                        Reponse : {resume.reponse}
                      </Typography>
                      <Typography
                        sx={{ mt: 1 }}
                        display={resume.commentaire ? "" : "none"}
                        variant="body2"
                        color="textSecondary"
                      >
                        Commentaire :<br /> {resume.commentaire}
                      </Typography>
                      <Typography
                        sx={{ mt: 1 }}
                        variant="body2"
                        color="textSecondary"
                      >
                        Pj : {resume.pj ? resume.pj : "Aucune pièce jointe"}
                      </Typography>
                    </Grid>
                  </Grid>
                }
                // action={
                //   <Grid container>
                //     <Grid item xs={12}>
                //       <IconButton
                //         title={`Modifier la réponse de la question N° ${index + 1}`}
                //         color="primary"
                //         onClick={(e) => setCurentIndex(index)}
                //       >
                //         <EditOutlined />
                //       </IconButton>
                //     </Grid>
                //   </Grid>
                // }
              />
            ))
          ) : (
            <CardHeader
              title={<p>Aucun résumé trouvé pour ce Lot.</p>}
              titleTypographyProps={{ variant: "h6", textAlign: "center" }}
            />
          )}
          <Grid m={2}>
            <Divider variant="middle" />
            <FormGroup sx={{ mt: 4 }}>
              <FormLabel>
                <Typography variant="body2">
                  <b>
                    Veuillez accepter les conditions pour pouvoir soumettre ce
                    dossier
                  </b>
                </Typography>
              </FormLabel>
              <FormControlLabel
                sx={{ mt: 1 }}
                control={
                  <Checkbox
                    checked={acceptCondition}
                    onClick={handleAcceptCondition}
                    name="accept"
                  />
                }
                label={
                  <Typography variant="body2">
                    Je sousigné(e), <b>{getConnectedUser()?.full_name}</b>,
                    representant légal de l'agence / association{" "}
                    <b>{String(association?.nom).toUpperCase() || ""}</b>,
                    certifie que les informations fournies dans ce dossier sont
                    exactes et sincères.
                  </Typography>
                }
                //<p>}
                // labelPlacement="start"
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ResumePostule;
